export default "__VITE_ASSET__RslwOqV5__"